import React, { useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import "./Pricing.css";

const Pricing = () => {
  const [phoneCopied, setPhoneCopied] = useState(false);

  const handleCopyPhone = () => {
    navigator.clipboard.writeText("+46767425416").then(() => {
      setPhoneCopied(true);
      setTimeout(() => setPhoneCopied(false), 2000);
    });
  };

  return (
    <div className="pricing-page">
      <section className="pricing-hero">
        <div className="pricing-badge"><span className="badge-dot"></span> Simple Pricing</div>
        <h1>Start Free,<br /><span className="gradient-text">Scale When Ready</span></h1>
        <p>Everything you need to chat with your documents — completely free. Need more? Let's talk.</p>
      </section>

      <section className="pricing-cards">
        {/* Free Tier */}
        <div className="pricing-card highlighted">
          <div className="pricing-popular">Current Plan</div>
          <h3>Free</h3>
          <div className="pricing-price">
            <span className="price-amount">$0</span>
            <span className="price-period">/forever</span>
          </div>
          <p className="pricing-desc">Full access to Contextly AI — no strings attached</p>
          <Link to="/" className="pricing-cta primary">Get Started <i className="fa fa-bolt"></i></Link>
          <ul className="pricing-features">
            <li><i className="fa fa-check"></i> Up to 15 sources per session</li>
            <li><i className="fa fa-check"></i> PDF, URL & text uploads</li>
            <li><i className="fa fa-check"></i> AI-powered chat with citations</li>
            <li><i className="fa fa-check"></i> Executive summaries & key topics</li>
            <li><i className="fa fa-check"></i> Powered by Gemini 2.5 Flash</li>
            <li><i className="fa fa-check"></i> Source guide per document</li>
            <li><i className="fa fa-check"></i> Dark & light themes</li>
          </ul>
        </div>

        {/* Enterprise */}
        <div className="pricing-card">
          <h3>Enterprise</h3>
          <div className="pricing-price">
            <span className="price-amount">Custom</span>
          </div>
          <p className="pricing-desc">On-scale deployment tailored for your organization</p>
          <a href="tel:+46767425416" className="pricing-cta secondary">
            <i className="fa fa-phone"></i> Contact Us
          </a>
          <ul className="pricing-features">
            <li><i className="fa fa-check"></i> Custom deployment & infrastructure</li>
            <li><i className="fa fa-check"></i> Unlimited sources & sessions</li>
            <li><i className="fa fa-check"></i> API access & integrations</li>
            <li><i className="fa fa-check"></i> Dedicated support & SLA</li>
            <li><i className="fa fa-check"></i> Custom LLM model selection</li>
            <li><i className="fa fa-check"></i> On-premise or private cloud</li>
          </ul>
          <div className="enterprise-contact">
            <p className="enterprise-phone-label">Or reach us directly:</p>
            <button className="enterprise-phone-btn" onClick={handleCopyPhone}>
              <i className={`fa ${phoneCopied ? 'fa-check' : 'fa-copy'}`}></i>
              {phoneCopied ? 'Copied!' : '+46 76 742 5416'}
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Pricing;
